import type { Dict } from '../i18n';

/* English text is the key (see ../i18n.ts). A new UI text needs an entry in de.ts, uk.ts and pl.ts. */
const dict: Dict = {
  "Loading…": "Wird geladen…",
  "Switch project": "Projekt wechseln",
  "All Projects": "Alle Projekte",
  "Search": "Suchen",
  "No matching project": "Kein passendes Projekt",
  "Switch team": "Team wechseln",
  "No team": "Kein Team",
  "All teams…": "Alle Teams…",
  "Recently visited:": "Zuletzt besucht:",
  "Teams": "Teams",
  "My View": "Meine Ansicht",
  "View Issues": "Einträge anzeigen",
  "Report Issue": "Eintrag erfassen",
  "Change Log": "Änderungsprotokoll",
  "Roadmap": "Roadmap",
  "Summary": "Zusammenfassung",
  "Summary|page": "Zusammenfassung",
  "Manage": "Verwaltung",
  "My Account": "Mein Konto",
  "RSS": "RSS",
  "Logout": "Abmelden",
  "Expand": "Ausklappen",
  "Collapse": "Einklappen",
  "Expand sidebar": "Seitenleiste ausklappen",
  "Collapse sidebar": "Seitenleiste einklappen",
  "Scroll to top": "Zum Seitenanfang",
  "Scroll to bottom": "Zum Seitenende",
  "Access level {level}": "Zugriffsrechte: {level}",
  "Access level {level} in {project}": "Zugriffsrechte in {project}: {level}",
  "Issue #": "Eintrag Nr.",
  "Jump to issue": "Zu Eintrag springen",
  "Page not found": "Seite nicht gefunden",
  "Back to My View": "Zurück zu Meine Ansicht",
  "just now": "gerade eben",
  "yesterday": "gestern",
  "Unassigned": "Nicht zugewiesen",
  "Feature": "Funktion",
  "Task": "Aufgabe",
  "Bug": "Fehler",
  "Priority": "Priorität",
  "Close": "Schließen",
  "Type": "Typ",
  "Key": "Nr.",
  "private": "privat",
  "pinned": "angeheftet",
  "Assignee": "Bearbeiter",
  "Reporter": "Reporter",
  "P": "P",
  "Status": "Status",
  "Comments": "Kommentare",
  "Attachments": "Anhänge",
  "Updated": "Aktualisiert",
  "Select all": "Alle auswählen",
  "Select {id}": "{id} auswählen",
  "No issues match your filters.": "Keine Einträge entsprechen deinen Filtern.",
  "None": "Keine",
  "Could not load: {error}": "Laden fehlgeschlagen: {error}",
  "E-mail on New": "E-Mail bei neuem Eintrag",
  "E-mail on Change of Handler": "E-Mail bei Änderung des Bearbeiters",
  "E-mail on Feedback": "E-Mail bei Rückmeldung",
  "E-mail on Resolved": "E-Mail bei Erledigung",
  "E-mail on Closed": "E-Mail bei Schließung",
  "E-mail on Reopened": "E-Mail bei Wiedereröffnung",
  "E-mail on Note Added": "E-Mail bei neuer Notiz",
  "E-mail on Status Change": "E-Mail bei Statusänderung",
  "E-mail on Priority Change": "E-Mail bei Prioritätsänderung",
  "The new passwords do not match.": "Die neuen Passwörter stimmen nicht überein.",
  "Account updated.": "Konto aktualisiert.",
  "Preferences saved.": "Einstellungen gespeichert.",
  "Edit Account": "Konto bearbeiten",
  "Username": "Benutzername",
  "Access Level": "Zugriffsrechte",
  "Real Name": "Vollständiger Name",
  "E-mail": "E-Mail",
  "Current Password": "Aktuelles Passwort",
  "New Password": "Neues Passwort",
  "Confirm Password": "Passwort bestätigen",
  "Update User": "Benutzer aktualisieren",
  "Member since {date} · last visit {visit}": "Mitglied seit {date} · letzter Besuch {visit}",
  "Assigned Projects": "Zugewiesene Projekte",
  "Preferences": "Einstellungen",
  "Color issue rows by status": "Eintragszeilen nach Status einfärben",
  "Dark mode": "Dunkler Modus",
  "Close image preview": "Bildvorschau schließen",
  "Language": "Sprache",
  "Default Project": "Standardprojekt",
  "Notes Sort Order": "Sortierung der Notizen",
  "Ascending (oldest first)": "Aufsteigend (älteste zuerst)",
  "Descending (newest first)": "Absteigend (neueste zuerst)",
  "Update Prefs": "Einstellungen speichern",
  "Sign-up is by invitation only. Ask a team administrator to invite you.": "Registrierung nur mit Einladung. Bitte einen Team-Administrator, dich einzuladen.",
  "Back to login": "Zurück zur Anmeldung",
  "Join {team}": "{team} beitreten",
  "Create your account": "Konto erstellen",
  "Create an account to accept the invitation.": "Erstelle ein Konto, um die Einladung anzunehmen.",
  "(optional)": "(optional)",
  "(at least 8 characters)": "(mindestens 8 Zeichen)",
  "Team name": "Teamname",
  "{name}'s team": "Team von {name}",
  "e.g. Acme": "z. B. Acme",
  "Creating…": "Wird erstellt…",
  "Create account and join": "Konto erstellen und beitreten",
  "Create account": "Konto erstellen",
  "Already have an account?": "Schon ein Konto?",
  "Log in": "Anmelden",
  "Go to login": "Zur Anmeldung",
  "This invitation to \"{team}\" has expired or was already used. Ask for a new one.": "Diese Einladung zu „{team}\" ist abgelaufen oder wurde schon verwendet. Bitte um eine neue.",
  "{who} invited you to the team \"{team}\". You're logged in as {user}.": "{who} hat dich in das Team „{team}\" eingeladen. Du bist als {user} angemeldet.",
  "A team administrator": "Ein Team-Administrator",
  "Joining…": "Wird beigetreten…",
  "Join the team": "Team beitreten",
  "Not you?": "Nicht du?",
  "Log out": "Abmelden",
  "and use another account.": "und verwende ein anderes Konto.",
  "Check your e-mail": "Prüfe deine E-Mails",
  "If an account uses this address, we sent it a link to choose a new password. The link is valid for 1 hour.": "Falls ein Konto diese Adresse verwendet, haben wir einen Link zum Festlegen eines neuen Passworts gesendet. Der Link ist 1 Stunde gültig.",
  "Reset password": "Passwort zurücksetzen",
  "Enter the e-mail address of your account.": "Gib die E-Mail-Adresse deines Kontos ein.",
  "Sending…": "Wird gesendet…",
  "Send reset link": "Link senden",
  "Choose a new password": "Neues Passwort festlegen",
  "The passwords do not match.": "Die Passwörter stimmen nicht überein.",
  "Repeat new password": "Neues Passwort wiederholen",
  "Saving…": "Wird gespeichert…",
  "Set password": "Passwort festlegen",
  "Choose your password": "Passwort festlegen",
  "Welcome, {name}! Your account was created with a temporary password. Please choose your own before you continue.": "Willkommen, {name}! Dein Konto wurde mit einem vorläufigen Passwort erstellt. Bitte lege vor dem Fortfahren ein eigenes fest.",
  "Temporary password": "Vorläufiges Passwort",
  "Save and continue": "Speichern und fortfahren",
  "drag cards between columns to change status": "Karten zwischen Spalten ziehen, um den Status zu ändern",
  "Search this board": "Board durchsuchen",
  "Only my issues": "Nur meine Einträge",
  "Show closed (30 days)": "Geschlossene zeigen (30 Tage)",
  "Clear filters": "Filter zurücksetzen",
  "Loading board…": "Board wird geladen…",
  "Showing the first {shown} of {total} issues. Pick a project to narrow the board.": "Es werden die ersten {shown} von {total} Einträgen angezeigt. Wähle ein Projekt, um das Board einzugrenzen.",
  "Drop issues here": "Einträge hier ablegen",
  "Send a Reminder": "Erinnerung senden",
  "Jump to Notes": "Zu den Notizen",
  "Jump to History": "Zur Historie",
  "Previous issue in the list": "Vorheriger Eintrag der Liste",
  "Next issue in the list": "Nächster Eintrag der Liste",
  "ID": "ID",
  "Project": "Projekt",
  "Category": "Kategorie",
  "View Status": "Sichtbarkeit",
  "public": "öffentlich",
  "Date Submitted": "Gemeldet am",
  "Last Update": "Letzte Änderung",
  "Assigned To": "Zugewiesen an",
  "Due Date": "Fälligkeitsdatum",
  "Severity": "Auswirkung",
  "Reproducibility": "Reproduzierbar",
  "Resolution": "Lösung",
  "Duplicate of": "Duplikat von",
  "Product Version": "Produktversion",
  "Target Version": "Zielversion",
  "Fixed in Version": "Behoben in Version",
  "Platform": "Plattform",
  "OS": "BS",
  "OS Version": "BS-Version",
  "Product Build": "Produkt-Build",
  "Projection": "Projektion",
  "ETA": "Aufwand",
  "Description": "Beschreibung",
  "Steps To Reproduce": "Schritte zur Reproduktion",
  "Additional Information": "Zusätzliche Informationen",
  "Tags": "Tags",
  "Edit": "Bearbeiten",
  "Assign To:": "Zuweisen an:",
  "Assign to": "Zuweisen an",
  "[Nobody]": "[Niemand]",
  "[Myself]": "[Mir selbst]",
  "[Reporter]": "[Reporter]",
  "Assign to me": "Mir zuweisen",
  "Change Status To:": "Status ändern auf:",
  "New status": "Neuer Status",
  "End Monitor": "Nicht mehr beobachten",
  "Monitor": "Beobachten",
  "Unstick": "Lösen",
  "Stick": "Anheften",
  "Clone": "Klonen",
  "Move": "Verschieben",
  "Delete issue {id} permanently? This cannot be undone.": "Eintrag {id} endgültig löschen? Das kann nicht rückgängig gemacht werden.",
  "Delete": "Löschen",
  "Move issue {id}": "Eintrag {id} verschieben",
  "Move to project": "In Projekt verschieben",
  "Select a project…": "Projekt wählen…",
  "If the category doesn't exist in the target project, it will be cleared.": "Gibt es die Kategorie im Zielprojekt nicht, wird sie geleert.",
  "Cancel": "Abbrechen",
  "Move Issues": "Einträge verschieben",
  "To (Ctrl+click for several)": "An (Strg+Klick für mehrere)",
  "Reminder": "Erinnerung",
  "Please have a look at this issue…": "Bitte schau dir diesen Eintrag an…",
  "The recipients get an e-mail, and the reminder is recorded as a note on the issue.": "Die Empfänger erhalten eine E-Mail, und die Erinnerung wird als Notiz am Eintrag gespeichert.",
  "Send": "Senden",
  "Change status of issue {id}": "Status von Eintrag {id} ändern",
  "Duplicate of issue #": "Duplikat von Eintrag Nr.",
  "The resolution will be set to \"reopened\".": "Die Lösung wird auf „wiedereröffnet\" gesetzt.",
  "Set status: {status}": "Status setzen: {status}",
  "Add a note (optional)": "Notiz hinzufügen (optional)",
  "Private": "Privat",
  "Time tracking (HH:MM)": "Zeiterfassung (HH:MM)",
  "Detach": "Entfernen",
  "No tags attached.": "Keine Tags zugeordnet.",
  "(Separate by \",\")": "(Mit „,\" trennen)",
  "Attach tags": "Tags zuordnen",
  "Existing tags": "Vorhandene Tags",
  "Attach": "Zuordnen",
  "The file content was not imported from Mantis": "Der Dateiinhalt wurde nicht aus Mantis importiert",
  "file missing": "Datei fehlt",
  "Delete {file}?": "{file} löschen?",
  "Attached Files": "Angehängte Dateien",
  "Updating Issue Information": "Eintragsdaten bearbeiten",
  "(none)": "(keine)",
  "Update Information": "Speichern",
  "Relationships": "Beziehungen",
  "Current issue": "Aktueller Eintrag",
  "Add": "Hinzufügen",
  "Delete relationship": "Beziehung löschen",
  "Delete this relationship?": "Diese Beziehung löschen?",
  "Users monitoring this issue": "Beobachter dieses Eintrags",
  "Remove": "Entfernen",
  "There are no users monitoring this issue.": "Niemand beobachtet diesen Eintrag.",
  "Add Note": "Notiz hinzufügen",
  "Add a note… (drop files here or paste a screenshot to attach them)": "Notiz hinzufügen… (Dateien hier ablegen oder Screenshot einfügen)",
  "Attach files": "Dateien anhängen",
  "Activities": "Aktivitäten",
  "Time tracking: {time}": "Zeiterfassung: {time}",
  "There are no notes attached to this issue.": "Zu diesem Eintrag gibt es keine Notizen.",
  "reminder": "Erinnerung",
  "edited {when}": "bearbeitet {when}",
  "Save": "Speichern",
  "Delete this note?": "Diese Notiz löschen?",
  "Make Public": "Öffentlich machen",
  "Make Private": "Privat machen",
  "Sticky Issue": "Angeheftet",
  "Duplicate ID": "Duplikat-ID",
  "New Issue": "Neuer Eintrag",
  "Note Added: {v}": "Notiz hinzugefügt: {v}",
  "Note Edited: {v}": "Notiz bearbeitet: {v}",
  "Note Deleted: {v}": "Notiz gelöscht: {v}",
  "Description Updated": "Beschreibung geändert",
  "Additional Information Updated": "Zusätzliche Informationen geändert",
  "Steps to Reproduce Updated": "Schritte zur Reproduktion geändert",
  "File Added: {v}": "Datei hinzugefügt: {v}",
  "File Deleted: {v}": "Datei gelöscht: {v}",
  "Note View State: {v}": "Sichtbarkeit der Notiz: {v}",
  "Issue Monitored: {v}": "Beobachtung begonnen: {v}",
  "Issue End Monitor: {v}": "Beobachtung beendet: {v}",
  "Relationship added": "Beziehung hinzugefügt",
  "Relationship deleted": "Beziehung gelöscht",
  "Issue cloned": "Eintrag geklont",
  "Issue generated from": "Eintrag erzeugt aus",
  "Tag Attached: {v}": "Tag zugeordnet: {v}",
  "Tag Detached: {v}": "Tag entfernt: {v}",
  "change ({type})": "Änderung ({type})",
  "Issue History": "Eintragshistorie",
  "Date Modified": "Geändert am",
  "Field": "Feld",
  "Change": "Änderung",
  "List": "Liste",
  "Board": "Board",
  "{n} selected": "{n} ausgewählt",
  "Clear selection": "Auswahl aufheben",
  "No options": "Keine Optionen",
  "CSV Export": "CSV-Export",
  "Search summary, description, notes or #id": "Zusammenfassung, Beschreibung, Notizen oder #ID durchsuchen",
  "[None]": "[Niemand]",
  "Monitored by me": "Von mir beobachtet",
  "Hide status": "Status ausblenden",
  "[none]": "[keine]",
  "resolved and above": "erledigt und höher",
  "closed": "geschlossen",
  "Reset filter ({n})": "Filter zurücksetzen ({n})",
  "Saved filters": "Gespeicherte Filter",
  "Saved filters…": "Gespeicherte Filter…",
  "shared by {user}": "geteilt von {user}",
  "Name for this filter:": "Name für diesen Filter:",
  "Share this filter with everyone? (Cancel = only me)": "Diesen Filter mit allen teilen? (Abbrechen = nur ich)",
  "Save Current Filter": "Aktuellen Filter speichern",
  "Delete this saved filter?": "Diesen gespeicherten Filter löschen?",
  "Delete saved filter": "Gespeicherten Filter löschen",
  "Delete filter…": "Filter löschen…",
  "Viewing Issues ({from} - {to} / {total})": "Einträge ({from} - {to} / {total})",
  "updating…": "wird aktualisiert…",
  "Per page": "Pro Seite",
  "{ok} updated, {failed} failed: ": "{ok} aktualisiert, {failed} fehlgeschlagen: ",
  "choose…": "auswählen…",
  "choose project…": "Projekt auswählen…",
  "select a project first": "zuerst ein Projekt wählen",
  "version": "Version",
  "Assign": "Zuweisen",
  "Update Status": "Status ändern",
  "Resolve": "Erledigen",
  "Update Priority": "Priorität ändern",
  "Update Category": "Kategorie ändern",
  "Update Target Version": "Zielversion ändern",
  "Update Fixed in Version": "„Behoben in Version\" ändern",
  "Update View Status": "Sichtbarkeit ändern",
  "Note text (required)": "Notiztext (Pflicht)",
  "Optional note": "Optionale Notiz",
  "OK": "OK",
  "Log in to your account.": "Melde dich bei deinem Konto an.",
  "Your password was changed. Log in with the new one.": "Dein Passwort wurde geändert. Melde dich mit dem neuen an.",
  "Username or e-mail": "Benutzername oder E-Mail",
  "Password": "Passwort",
  "Logging in…": "Anmeldung…",
  "Forgot password?": "Passwort vergessen?",
  "New here?": "Neu hier?",
  "Create an account": "Konto erstellen",
  "Team": "Team",
  "Projects": "Projekte",
  "Custom Fields": "Benutzerdefinierte Felder",
  "New project name": "Name des neuen Projekts",
  "Create Project": "Projekt anlegen",
  "Create your team's first project to start tracking issues.": "Lege das erste Projekt deines Teams an, um Einträge zu erfassen.",
  "Name": "Name",
  "Parent": "Übergeordnet",
  "Enabled": "Aktiv",
  "Issues": "Einträge",
  "read-only": "schreibgeschützt",
  "yes": "ja",
  "no": "nein",
  "« Projects": "« Projekte",
  "Edit Project: {name}": "Projekt bearbeiten: {name}",
  "Project Name": "Projektname",
  "Inherit global categories": "Globale Kategorien übernehmen",
  "Subproject of": "Unterprojekt von",
  "Update Project": "Projekt speichern",
  "Categories": "Kategorien",
  "[global]": "[global]",
  "Auto-assign new issues in this category to": "Neue Einträge dieser Kategorie automatisch zuweisen an",
  "(no default assignee)": "(kein Standardbearbeiter)",
  "Rename category": "Kategorie umbenennen",
  "Rename": "Umbenennen",
  "Delete category {name}?": "Kategorie {name} löschen?",
  "New category": "Neue Kategorie",
  "Add Category": "Kategorie hinzufügen",
  "Versions": "Versionen",
  "Version": "Version",
  "Released": "Veröffentlicht",
  "Obsolete": "Veraltet",
  "Date": "Datum",
  "Rename version (also updates issues)": "Version umbenennen (ändert auch die Einträge)",
  "Delete version {name}?": "Version {name} löschen?",
  "New version": "Neue Version",
  "released": "veröffentlicht",
  "Add Version": "Version hinzufügen",
  "Project Members (access overrides)": "Projektmitglieder (abweichende Rechte)",
  "No per-project access overrides. Public projects use each member's team access level.": "Keine projektbezogenen Rechte. Öffentliche Projekte verwenden die Teamrechte jedes Mitglieds.",
  "user…": "Benutzer…",
  "Add / Update": "Hinzufügen / ändern",
  "No custom fields defined.": "Keine benutzerdefinierten Felder vorhanden.",
  "Display on report": "Beim Erfassen anzeigen",
  "Display on update": "Beim Bearbeiten anzeigen",
  "Display on resolve": "Beim Erledigen anzeigen",
  "Display on close": "Beim Schließen anzeigen",
  "Required on report": "Pflicht beim Erfassen",
  "Required on update": "Pflicht beim Bearbeiten",
  "Required on resolve": "Pflicht beim Erledigen",
  "Required on close": "Pflicht beim Schließen",
  "Add to filters": "In Filtern anbieten",
  "New Custom Field": "Neues benutzerdefiniertes Feld",
  "Possible values (a|b|c)": "Mögliche Werte (a|b|c)",
  "Default value": "Standardwert",
  "Regular expression": "Regulärer Ausdruck",
  "Read access": "Lesezugriff",
  "Write access": "Schreibzugriff",
  "Min. length": "Min. Länge",
  "Max. length": "Max. Länge",
  "Linked projects": "Verknüpfte Projekte",
  "Possible values": "Mögliche Werte",
  "Delete custom field {name} and all its values?": "Feld {name} mit allen Werten löschen?",
  "Rename team": "Team umbenennen",
  "Joined": "Beigetreten",
  "Last Visit": "Letzter Besuch",
  "you": "du",
  "Has not replaced the temporary password yet": "Hat das vorläufige Passwort noch nicht geändert",
  "temporary password": "vorläufiges Passwort",
  "Leave \"{team}\"?": "„{team}\" verlassen?",
  "Remove {user} from the team?": "{user} aus dem Team entfernen?",
  "Leave": "Verlassen",
  "The access level applies to every project of the team; a project's members list can raise or lower it for that project. Administrators manage the team and its projects.": "Die Zugriffsrechte gelten für alle Projekte des Teams; in der Mitgliederliste eines Projekts lassen sie sich für dieses Projekt erhöhen oder senken. Administratoren verwalten das Team und seine Projekte.",
  "Invite people": "Personen einladen",
  "name@company.com": "name@firma.de",
  "Send invitation": "Einladung senden",
  "Invitation sent to {email}. If the e-mail doesn't arrive, send them this link:": "Einladung an {email} gesendet. Falls die E-Mail nicht ankommt, schick diesen Link:",
  "Pending invitation": "Offene Einladung",
  "Invited by": "Eingeladen von",
  "Expires": "Läuft ab",
  "Revoke": "Zurückziehen",
  "Copied": "Kopiert",
  "Copy": "Kopieren",
  "Back to projects": "Zurück zu den Projekten",
  "Other teams": "Andere Teams",
  "Assigned to Me (Unresolved)": "Mir zugewiesen (offen)",
  "Reported by Me": "Von mir gemeldet",
  "Resolved": "Erledigt",
  "Recently Modified": "Kürzlich geändert",
  "Monitored by Me": "Von mir beobachtet",
  "Nothing here.": "Hier ist nichts.",
  "View all {n} →": "Alle {n} anzeigen →",
  "has been reported.": "wurde erfasst.",
  "Required fields are marked with an asterisk": "Pflichtfelder sind mit einem Sternchen markiert",
  "Select a project": "Projekt wählen",
  "Issue type": "Eintragstyp",
  "Component (category)": "Komponente (Kategorie)",
  "Select…": "Auswählen…",
  "global": "global",
  "What happened? What did you expect?": "Was ist passiert? Was hast du erwartet?",
  "Automatic / unassigned": "Automatisch / nicht zugewiesen",
  "Labels": "Labels",
  "label1, label2": "Label1, Label2",
  "Affects version": "Betrifft Version",
  "Fix version (target)": "Zielversion",
  "Fewer fields": "Weniger Felder",
  "More fields (steps, environment, visibility)": "Weitere Felder (Schritte, Umgebung, Sichtbarkeit)",
  "Steps to reproduce": "Schritte zur Reproduktion",
  "Additional information": "Zusätzliche Informationen",
  "Visibility": "Sichtbarkeit",
  "Public": "Öffentlich",
  "Build": "Build",
  "OS version": "BS-Version",
  "Report Stay (report another issue)": "Hierbleiben (weiteren Eintrag erfassen)",
  "Submitting…": "Wird gesendet…",
  "Submit Issue": "Eintrag absenden",
  "Report Issue (clone of {id})": "Eintrag erfassen (Klon von {id})",
  "No unreleased versions with planned issues.": "Keine unveröffentlichten Versionen mit geplanten Einträgen.",
  "(scheduled {date})": "(geplant für {date})",
  "View issues": "Einträge anzeigen",
  "{resolved} of {total} resolved": "{resolved} von {total} erledigt",
  "No released versions.": "Keine veröffentlichten Versionen.",
  "(released {date})": "(veröffentlicht am {date})",
  "No issues.": "Keine Einträge.",
  "By Status": "Nach Status",
  "By Severity": "Nach Auswirkung",
  "open": "offen",
  "total": "gesamt",
  "By Project": "Nach Projekt",
  "By Assignee": "Nach Bearbeiter",
  "resolved": "erledigt",
  "(unassigned)": "(nicht zugewiesen)",
  "Search teams": "Teams suchen",
  "You're not in a team yet. Create one below, or open the invitation link someone sent you.": "Du bist noch in keinem Team. Erstelle unten eines oder öffne den Einladungslink, den du bekommen hast.",
  "Open {team}": "{team} öffnen",
  "More options": "Weitere Optionen",
  "Open team": "Team öffnen",
  "Members & invitations": "Mitglieder & Einladungen",
  "Leave the team \"{team}\"? You lose access to its projects.": "Team „{team}\" verlassen? Du verlierst den Zugriff auf seine Projekte.",
  "Leave team": "Team verlassen",
  "Create a team": "Team erstellen",
  "e.g. Mobile squad": "z. B. Mobile-Team",
  "Create team": "Team erstellen",
  "new": "neu",
  "feedback": "Rückmeldung",
  "acknowledged": "anerkannt",
  "confirmed": "bestätigt",
  "assigned": "zugewiesen",
  "none": "keine",
  "low": "niedrig",
  "normal": "normal",
  "high": "hoch",
  "urgent": "dringend",
  "immediate": "sofort",
  "feature": "Feature-Wunsch",
  "trivial": "trivial",
  "text": "Text",
  "tweak": "Feinschliff",
  "minor": "kleinerer Fehler",
  "major": "größerer Fehler",
  "crash": "Absturz",
  "block": "Blocker",
  "always": "immer",
  "sometimes": "manchmal",
  "random": "zufällig",
  "have not tried": "nicht getestet",
  "unable to reproduce": "nicht reproduzierbar",
  "N/A": "N/A",
  "fixed": "behoben",
  "reopened": "wiedereröffnet",
  "not fixable": "nicht behebbar",
  "duplicate": "doppelt",
  "no change required": "keine Änderung notwendig",
  "suspended": "aufgeschoben",
  "minor fix": "kleinere Korrektur",
  "major rework": "größere Überarbeitung",
  "redesign": "Neuentwurf",
  "< 1 day": "< 1 Tag",
  "2-3 days": "2-3 Tage",
  "< 1 week": "< 1 Woche",
  "< 1 month": "< 1 Monat",
  "> 1 month": "> 1 Monat",
  "viewer": "Betrachter",
  "reporter": "Reporter",
  "updater": "Bearbeiter",
  "developer": "Entwickler",
  "manager": "Manager",
  "administrator": "Administrator",
  "development": "Entwicklung",
  "release": "Release",
  "stable": "stabil",
  "obsolete": "veraltet",
  "duplicate of": "Duplikat von",
  "related to": "verwandt mit",
  "parent of": "übergeordnet zu",
  "child of": "untergeordnet zu",
  "has duplicate": "hat Duplikat",
  "String": "Zeichenkette",
  "Numeric": "Ganzzahl",
  "Float": "Kommazahl",
  "Enumeration": "Aufzählung",
  "Checkbox": "Kontrollkästchen",
  "Multiselection list": "Mehrfachauswahl",
  "Radio": "Optionsfelder",
  "Textarea": "Textbereich",
  "won't fix": "wird nicht behoben",
  "Your account may be disabled or the username/password you entered is incorrect.": "Dein Konto ist möglicherweise deaktiviert, oder Benutzername/Passwort sind falsch.",
  "Too many attempts. Please wait a few minutes and try again.": "Zu viele Versuche. Bitte warte ein paar Minuten und versuche es erneut.",
  "That username is already taken.": "Dieser Benutzername ist bereits vergeben.",
  "An account with this e-mail address already exists. Log in or reset your password.": "Ein Konto mit dieser E-Mail-Adresse existiert bereits. Melde dich an oder setze dein Passwort zurück.",
  "Password must have at least 8 characters": "Das Passwort muss mindestens 8 Zeichen haben",
  "Username must have at least 2 characters": "Der Benutzername muss mindestens 2 Zeichen haben",
  "Username may only contain letters, digits and . _ @ + -": "Der Benutzername darf nur Buchstaben, Ziffern und . _ @ + - enthalten",
  "Invalid e-mail address": "Ungültige E-Mail-Adresse",
  "Team name is required": "Teamname ist erforderlich",
  "The current password is incorrect.": "Das aktuelle Passwort ist falsch.",
  "The new password must be different from the current one.": "Das neue Passwort muss sich vom aktuellen unterscheiden.",
  "Another account already uses this e-mail address.": "Ein anderes Konto verwendet diese E-Mail-Adresse bereits.",
  "This invitation is no longer valid. Ask for a new one.": "Diese Einladung ist nicht mehr gültig. Bitte um eine neue.",
  "This invitation link is not valid.": "Dieser Einladungslink ist ungültig.",
  "This link has expired or was already used. Request a new one.": "Dieser Link ist abgelaufen oder wurde bereits verwendet. Fordere einen neuen an.",
  "Sign-up is by invitation only.": "Registrierung nur mit Einladung.",
  "Please change your password first.": "Bitte ändere zuerst dein Passwort.",
  "Not logged in": "Nicht angemeldet",
  "Create or join a team first.": "Erstelle zuerst ein Team oder tritt einem bei.",
  "Team administrator access required.": "Team-Administratorrechte erforderlich.",
  "A team needs at least one administrator. Make someone else an administrator first.": "Ein Team braucht mindestens einen Administrator. Mache zuerst jemand anderen zum Administrator.",
  "This person is already in the team.": "Diese Person ist bereits im Team.",
  "Only team members can be added to a project. Invite them to the team first.": "Nur Teammitglieder können einem Projekt hinzugefügt werden. Lade die Person zuerst ins Team ein.",
  "A project with this name already exists.": "Ein Projekt mit diesem Namen existiert bereits.",
  "Summary is required": "Zusammenfassung ist erforderlich",
  "Description is required": "Beschreibung ist erforderlich",
  "Category is required": "Kategorie ist erforderlich",
  "Internal server error": "Interner Serverfehler",
  "Not found": "Nicht gefunden",
  "Access denied": "Zugriff verweigert",
  "Open": "Offen",
  "Closed": "Geschlossen",
  "Total": "Gesamt",
  "{n} minutes ago": {"one": "vor {n} Minute", "other": "vor {n} Minuten"},
  "{n} hours ago": {"one": "vor {n} Stunde", "other": "vor {n} Stunden"},
  "{n} days ago": {"one": "vor {n} Tag", "other": "vor {n} Tagen"},
  "{n} members": {"one": "{n} Mitglied", "other": "{n} Mitglieder"},
  "{n} issues updated.": {"one": "{n} Eintrag aktualisiert.", "other": "{n} Einträge aktualisiert."},
  "Delete {n} issues permanently?": {"one": "{n} Eintrag endgültig löschen?", "other": "{n} Einträge endgültig löschen?"},
  "{n} projects": {"one": "{n} Projekt", "other": "{n} Projekte"},
  "{count} of {n} projects": {"one": "{count} von {n} Projekt", "other": "{count} von {n} Projekten"},
  "{n} days left": {"one": "noch {n} Tag", "other": "noch {n} Tage"},
  "{resolved} of {n} issues resolved": {"one": "{resolved} von {n} Eintrag erledigt", "other": "{resolved} von {n} Einträgen erledigt"},
  "{n} issues": {"one": "{n} Eintrag", "other": "{n} Einträge"},
  "Import": "Import",
  "API": "API",
  "Issue created": "Eintrag erstellt",
  "Issue changed (status, assignee, fields)": "Eintrag geändert (Status, Bearbeiter, Felder)",
  "Note added (public notes only)": "Notiz hinzugefügt (nur öffentliche Notizen)",
  "API keys": "API-Schlüssel",
  "Key name, e.g. Ship": "Name des Schlüssels, z. B. Ship",
  "Read only": "Nur lesen",
  "Create key": "Schlüssel erstellen",
  "Key \"{name}\" created. Copy it now — it is shown only once:": "Schlüssel „{name}\" erstellt. Kopiere ihn jetzt — er wird nur einmal angezeigt:",
  "Requests with a key act as the person who created it, with their rights in this team. Revoke a key when it is no longer needed.": "Anfragen mit einem Schlüssel laufen im Namen der Person, die ihn erstellt hat, mit ihren Rechten in diesem Team. Ziehe Schlüssel zurück, die nicht mehr gebraucht werden.",
  "Access": "Zugriff",
  "Created by": "Erstellt von",
  "Created": "Erstellt",
  "Last used": "Zuletzt verwendet",
  "read only": "nur lesen",
  "read & write": "lesen & schreiben",
  "revoked": "zurückgezogen",
  "Revoke the key \"{name}\"? Programs using it stop working.": "Schlüssel „{name}\" zurückziehen? Programme, die ihn verwenden, funktionieren dann nicht mehr.",
  "HTTP {status} in {ms} ms": "HTTP {status} in {ms} ms",
  "Webhooks (send issues to another system)": "Webhooks (Einträge an ein anderes System senden)",
  "New webhook": "Neuer Webhook",
  "Test sent to \"{name}\": {result}": "Test an „{name}\" gesendet: {result}",
  "When an issue is created or changed, the server sends a POST request with JSON to the endpoint. Each request carries the header X-BugTracker-Signature: sha256=HMAC(secret, body), so the receiver can check that it came from here.": "Wenn ein Eintrag erstellt oder geändert wird, sendet der Server eine POST-Anfrage mit JSON an den Endpunkt. Jede Anfrage trägt den Header X-BugTracker-Signature: sha256=HMAC(secret, body), damit der Empfänger die Herkunft prüfen kann.",
  "Endpoint": "Endpunkt",
  "Events": "Ereignisse",
  "Last delivery": "Letzte Zustellung",
  "Send test": "Test senden",
  "Log": "Protokoll",
  "Delete the webhook \"{name}\"?": "Webhook „{name}\" löschen?",
  "Webhook \"{name}\" saved. Its signing secret (for checking X-BugTracker-Signature):": "Webhook „{name}\" gespeichert. Sein Signatur-Geheimnis (zum Prüfen von X-BugTracker-Signature):",
  "Done": "Fertig",
  "Edit webhook": "Webhook bearbeiten",
  "e.g. Ship": "z. B. Ship",
  "API endpoint (URL)": "API-Endpunkt (URL)",
  "All projects": "Alle Projekte",
  "Extra headers (one per line, e.g. Authorization: Bearer <key of the other system>)": "Zusätzliche Header (einer pro Zeile, z. B. Authorization: Bearer <Schlüssel des anderen Systems>)",
  "JSON payload": "JSON-Payload",
  "(empty = standard payload with the whole issue)": "(leer = Standard-Payload mit dem ganzen Eintrag)",
  "Placeholders: {{event}}, {{issue.id}}, {{issue.summary}}, {{issue.status}}, {{issue.project.name}}, {{issue.handler.username}}, {{issue.url}}, {{actor.username}}, {{note.text}}. {{name|json}} inserts a value as JSON, e.g. {{issue|json}} for the whole issue.": "Platzhalter: {{event}}, {{issue.id}}, {{issue.summary}}, {{issue.status}}, {{issue.project.name}}, {{issue.handler.username}}, {{issue.url}}, {{actor.username}}, {{note.text}}. {{name|json}} fügt einen Wert als JSON ein, z. B. {{issue|json}} für den ganzen Eintrag.",
  "Insert example": "Beispiel einfügen",
  "Preview with the latest issue": "Vorschau mit dem neuesten Eintrag",
  "Signing secret:": "Signatur-Geheimnis:",
  "Create a new secret? The receiver must be updated.": "Neues Geheimnis erzeugen? Der Empfänger muss angepasst werden.",
  "New secret": "Neues Geheimnis",
  "Deliveries of \"{name}\"": "Zustellungen von „{name}\"",
  "Nothing was sent yet.": "Noch nichts gesendet.",
  "Time": "Zeit",
  "Event": "Ereignis",
  "Issue": "Eintrag",
  "Result": "Ergebnis",
  "Request": "Anfrage",
  "Response": "Antwort",
  "the key: team, user, read-only": "der Schlüssel: Team, Benutzer, nur lesen",
  "valid values for status, priority, severity, resolution …": "gültige Werte für Status, Priorität, Auswirkung, Lösung …",
  "projects of the team": "Projekte des Teams",
  "categories, versions and custom fields of a project": "Kategorien, Versionen und benutzerdefinierte Felder eines Projekts",
  "members of the team": "Mitglieder des Teams",
  "issues; filters: project, status, priority, severity, handler, reporter, category, target_version, search, updated_since, include_closed, page, per_page (max 500), include=notes": "Einträge; Filter: project, status, priority, severity, handler, reporter, category, target_version, search, updated_since, include_closed, page, per_page (max. 500), include=notes",
  "one issue with its notes": "ein Eintrag mit seinen Notizen",
  "create an issue (JSON)": "Eintrag erstellen (JSON)",
  "change an issue; \"note\" adds a note at the same time": "Eintrag ändern; „note\" fügt gleichzeitig eine Notiz hinzu",
  "add a note: {\"text\": \"...\", \"private\": false}": "Notiz hinzufügen: {\"text\": \"...\", \"private\": false}",
  "REST API": "REST-API",
  "Base URL:": "Basis-URL:",
  "send the key as": "Schlüssel senden als",
  "or": "oder",
  "Values like status or priority can be given as names (\"high\") or Mantis numbers (40); projects, categories and people by name or id. The SOAP API for Mantis tools stays available at /api/soap/mantisconnect.php.": "Werte wie Status oder Priorität können als Namen („high\") oder Mantis-Zahlen (40) angegeben werden; Projekte, Kategorien und Personen per Name oder ID. Die SOAP-API für Mantis-Werkzeuge bleibt unter /api/soap/mantisconnect.php erreichbar.",
  "The upload was interrupted.": "Das Hochladen wurde unterbrochen.",
  "Reading the dump": "Dump wird gelesen",
  "Starting…": "Wird gestartet…",
  "Big databases take a while (about 25 minutes for 20,000 issues). You can leave this page and come back later.": "Große Datenbanken brauchen eine Weile (etwa 25 Minuten für 20.000 Einträge). Du kannst die Seite verlassen und später wiederkommen.",
  "Importing": "Import läuft",
  "Everything is written in one step at the end; until then the team does not change.": "Alles wird am Ende in einem Schritt geschrieben; bis dahin ändert sich am Team nichts.",
  "The last import failed: {error}": "Der letzte Import ist fehlgeschlagen: {error}",
  "Import from Mantis": "Import aus Mantis",
  "Brings projects, issues with their numbers, notes, history, tags, relationships and people from a MantisBT database into this team. People can be matched with the members of the team; everyone else gets an account that keeps their Mantis password.": "Übernimmt Projekte, Einträge mit ihren Nummern, Notizen, Historie, Tags, Beziehungen und Personen aus einer MantisBT-Datenbank in dieses Team. Personen können Teammitgliedern zugeordnet werden; alle anderen erhalten ein Konto mit ihrem Mantis-Passwort.",
  "Mantis database dump (.sql or .sql.gz)": "Mantis-Datenbank-Dump (.sql oder .sql.gz)",
  "Make the dump with mysqldump or the phpMyAdmin export (SQL format). The attachment folder can be chosen in the next step.": "Erstelle den Dump mit mysqldump oder dem phpMyAdmin-Export (SQL-Format). Den Anhangsordner kannst du im nächsten Schritt wählen.",
  "Uploading the dump": "Dump wird hochgeladen",
  "Upload and read": "Hochladen und lesen",
  "The import did not finish: {error}": "Der Import wurde nicht abgeschlossen: {error}",
  "What the dump contains": "Inhalt des Dumps",
  "People": "Personen",
  "Choose who each Mantis user is in this team. \"New account\" creates an account with the Mantis username and password and adds it to the team.": "Wähle, wer jeder Mantis-Benutzer in diesem Team ist. „Neues Konto\" erstellt ein Konto mit dem Mantis-Benutzernamen und -Passwort und fügt es dem Team hinzu.",
  "Mantis user": "Mantis-Benutzer",
  "In this team": "In diesem Team",
  "disabled": "deaktiviert",
  "New account": "Neues Konto",
  "Start": "Start",
  "Import into this team": "In dieses Team importieren",
  "Cancel this import? The uploaded dump and files are deleted.": "Diesen Import abbrechen? Der hochgeladene Dump und die Dateien werden gelöscht.",
  "Cancel import": "Import abbrechen",
  "Attachments (optional)": "Anhänge (optional)",
  "Mantis kept {n} attachment files on its server disk. Choose that upload folder to bring the files along; without it, the attachments are listed but their files are missing (they can be added with a new import later).": "Mantis hat {n} Anhangsdateien auf der Festplatte des Servers abgelegt. Wähle diesen Upload-Ordner, um die Dateien mitzunehmen; ohne ihn werden die Anhänge aufgeführt, aber ihre Dateien fehlen (sie können später mit einem neuen Import ergänzt werden).",
  "Files received: {received} of {needed}": "Empfangene Dateien: {received} von {needed}",
  "Mantis upload folder": "Mantis-Upload-Ordner",
  "{found} of the {all} files in the folder belong to this dump.": "{found} der {all} Dateien im Ordner gehören zu diesem Dump.",
  "Uploading files": "Dateien werden hochgeladen",
  "Notes": "Notizen",
  "History entries": "Historieneinträge",
  "New projects": "Neue Projekte",
  "Existing projects": "Vorhandene Projekte",
  "New accounts": "Neue Konten",
  "Matched people": "Zugeordnete Personen",
  "Attachment files": "Anhangsdateien",
  "Replaced issues": "Ersetzte Einträge",
  "Import finished": "Import abgeschlossen",
  "\"{name}\" was imported into the team.": "„{name}\" wurde in das Team importiert.",
  "Go to the issues": "Zu den Einträgen",
  "New accounts (they log in with their Mantis password):": "Neue Konten (Anmeldung mit dem Mantis-Passwort):",
  "{n} notes": {"one": "{n} Notiz", "other": "{n} Notizen"},
  "{n} people": {"one": "{n} Person", "other": "{n} Personen"},
  "{n} attachments": {"one": "{n} Anhang", "other": "{n} Anhänge"},
  "Replace {n} issues of this team that have the same numbers (their notes and history are replaced too)": {"one": "{n} Eintrag dieses Teams mit derselben Nummer ersetzen (seine Notizen und Historie werden mit ersetzt)", "other": "{n} Einträge dieses Teams mit denselben Nummern ersetzen (ihre Notizen und Historie werden mit ersetzt)"},
  "Upload {n} files": {"one": "{n} Datei hochladen", "other": "{n} Dateien hochladen"},
  "{n} warnings": {"one": "{n} Warnung", "other": "{n} Warnungen"},
  "Give these issues new numbers; references like #123 in texts are updated. The list of new numbers can be downloaded after the import.": "Diesen Einträgen neue Nummern geben; Verweise wie #123 in Texten werden angepasst. Die Liste der neuen Nummern kann nach dem Import heruntergeladen werden.",
  "Issues with new numbers": "Einträge mit neuen Nummern",
  "Download the list of new issue numbers (CSV)": "Liste der neuen Eintragsnummern herunterladen (CSV)",
  "{n} issue numbers of this dump are already used on this server.": {"one": "{n} Eintragsnummer dieses Dumps ist auf diesem Server bereits vergeben.", "other": "{n} Eintragsnummern dieses Dumps sind auf diesem Server bereits vergeben."},
  "The {n} issues whose numbers other teams use get new numbers.": {"one": "Der {n} Eintrag, dessen Nummer ein anderes Team verwendet, erhält eine neue Nummer.", "other": "Die {n} Einträge, deren Nummern andere Teams verwenden, erhalten neue Nummern."},
  "Type {name} to confirm": "Zur Bestätigung {name} eingeben",
  "Your password": "Ihr Passwort",
  "Delete project": "Projekt löschen",
  "Export team data": "Teamdaten exportieren",
  "Downloads everything of the team as a .tar.gz archive: members, projects, issues with notes, history and relationships (JSON), and optionally the attachment files. Windows, macOS and 7-Zip open it.": "Lädt alle Daten des Teams als .tar.gz-Archiv herunter: Mitglieder, Projekte, Einträge mit Notizen, Historie und Beziehungen (JSON) und auf Wunsch die Dateianhänge. Windows, macOS und 7-Zip können es öffnen.",
  "Include attachment files (can be large)": "Dateianhänge einschließen (kann groß werden)",
  "Download export": "Export herunterladen",
  "Delete team": "Team löschen",
  "Delete account": "Konto löschen",
  "Delete my account": "Mein Konto löschen",
  "Removes your name, e-mail address, password and memberships. Issues and notes you wrote stay in their teams and show \"Deleted user\". This cannot be undone.": "Entfernt Ihren Namen, Ihre E-Mail-Adresse, Ihr Passwort und Ihre Mitgliedschaften. Ihre Einträge und Notizen bleiben in den Teams und zeigen „Deleted user“. Das kann nicht rückgängig gemacht werden.",
  "You are the only member of {teams}; deleting your account deletes these teams with all their projects and issues.": "Sie sind das einzige Mitglied von {teams}; mit Ihrem Konto werden diese Teams samt allen Projekten und Einträgen gelöscht.",
  "You are the only administrator of {teams}. Make another member an administrator (Manage → Team) or delete the team first.": "Sie sind der einzige Administrator von {teams}. Machen Sie zuerst ein anderes Mitglied zum Administrator (Verwaltung → Team) oder löschen Sie das Team.",
  "Type the name of the team to confirm.": "Geben Sie zur Bestätigung den Namen des Teams ein.",
  "The password is incorrect.": "Das Passwort ist falsch.",
  "Type the name of the project to confirm.": "Geben Sie zur Bestätigung den Namen des Projekts ein.",
  "This project has subprojects. Delete them or move them to another project first.": "Dieses Projekt hat Unterprojekte. Löschen Sie sie zuerst oder verschieben Sie sie in ein anderes Projekt.",
  "An import into this team is running. Wait for it to finish or cancel it first.": "Gerade läuft ein Import in dieses Team. Warten Sie, bis er fertig ist, oder brechen Sie ihn zuerst ab.",
  "Deletes the project with its {n} issues, their notes, history and attachments. This cannot be undone.": {"one": "Löscht das Projekt mit seinem {n} Eintrag samt Notizen, Historie und Anhängen. Das kann nicht rückgängig gemacht werden.", "other": "Löscht das Projekt mit seinen {n} Einträgen samt Notizen, Historie und Anhängen. Das kann nicht rückgängig gemacht werden."},
  "Deletes the team with its {n} projects, all issues and files, API keys and webhooks. Members lose access; their accounts stay. This cannot be undone, so export the data first if you may need it.": {"one": "Löscht das Team mit seinem {n} Projekt, allen Einträgen und Dateien, API-Schlüsseln und Webhooks. Die Mitglieder verlieren den Zugriff, ihre Konten bleiben bestehen. Das kann nicht rückgängig gemacht werden – exportieren Sie die Daten vorher, falls Sie sie noch brauchen.", "other": "Löscht das Team mit seinen {n} Projekten, allen Einträgen und Dateien, API-Schlüsseln und Webhooks. Die Mitglieder verlieren den Zugriff, ihre Konten bleiben bestehen. Das kann nicht rückgängig gemacht werden – exportieren Sie die Daten vorher, falls Sie sie noch brauchen."},
  "A NEW issue has been reported by {user}.": "Ein NEUER Eintrag wurde von {user} gemeldet.",
  "The issue has been ASSIGNED by {user}.": "Der Eintrag wurde von {user} ZUGEWIESEN.",
  "The status of the issue changed from {from} to {to} (by {user}).": "Der Status des Eintrags wurde von {from} auf {to} geändert (von {user}).",
  "A NOTE has been added to this issue by {user}.": "{user} hat eine NOTIZ zu diesem Eintrag hinzugefügt.",
  "The priority of the issue was changed by {user}.": "{user} hat die Priorität des Eintrags geändert.",
  "The issue has been UPDATED by {user} ({fields}).": "Der Eintrag wurde von {user} GEÄNDERT ({fields}).",
  "A relationship to issue #{id} was added (by {user}).": "Eine Beziehung zu Eintrag #{id} wurde hinzugefügt (von {user}).",
  "Issue ID": "Eintrags-ID",
  "(note by {user})": "(Notiz von {user})",
  "Reset your {app} password": "{app}-Passwort zurücksetzen",
  "Hello {user},": "Hallo {user},",
  "open this link to choose a new password (valid for 1 hour):": "öffnen Sie diesen Link, um ein neues Passwort zu wählen (1 Stunde gültig):",
  "If you didn't ask for this, ignore this e-mail.": "Wenn Sie das nicht angefordert haben, ignorieren Sie diese E-Mail.",
  "{user} sent you a reminder regarding this issue:": "{user} hat Ihnen eine Erinnerung zu diesem Eintrag gesendet:",
  "{user} invited you to the team \"{team}\" on {app}": "{user} hat Sie in das Team „{team}“ auf {app} eingeladen",
  "{user} invited you to join the team \"{team}\" on {app}.": "{user} hat Sie eingeladen, dem Team „{team}“ auf {app} beizutreten.",
  "Hello,": "Hallo,",
  "Accept the invitation (valid for {n} days):": {"one": "Einladung annehmen ({n} Tag gültig):", "other": "Einladung annehmen ({n} Tage gültig):"},
  "Confirm your e-mail address for {app}": "Bestätigen Sie Ihre E-Mail-Adresse für {app}",
  "please confirm your e-mail address by opening this link (valid for 7 days):": "bitte bestätigen Sie Ihre E-Mail-Adresse, indem Sie diesen Link öffnen (7 Tage gültig):",
  "If you didn't create an account, ignore this e-mail.": "Wenn Sie kein Konto angelegt haben, ignorieren Sie diese E-Mail.",
  "Add an e-mail address to your account first.": "Fügen Sie Ihrem Konto zuerst eine E-Mail-Adresse hinzu.",
  "Your e-mail address is already confirmed.": "Ihre E-Mail-Adresse ist bereits bestätigt.",
  "Too many e-mails. Please wait an hour and try again.": "Zu viele E-Mails. Bitte warten Sie eine Stunde und versuchen Sie es erneut.",
  "This link is for an e-mail address the account no longer uses.": "Dieser Link gilt für eine E-Mail-Adresse, die das Konto nicht mehr verwendet.",
  "Confirm your e-mail address before inviting people. The link is in the e-mail we sent you.": "Bestätigen Sie Ihre E-Mail-Adresse, bevor Sie Personen einladen. Der Link steht in der E-Mail, die wir Ihnen geschickt haben.",
  "Please confirm your e-mail address {email}: open the link in the e-mail we sent you.": "Bitte bestätigen Sie Ihre E-Mail-Adresse {email}: Öffnen Sie den Link in der E-Mail, die wir Ihnen geschickt haben.",
  "Sent. Check your inbox.": "Gesendet. Sehen Sie in Ihrem Posteingang nach.",
  "Send the link again": "Link erneut senden",
  "Confirm e-mail address": "E-Mail-Adresse bestätigen",
  "Thank you, your e-mail address is confirmed.": "Danke, Ihre E-Mail-Adresse ist bestätigt.",
  "Continue": "Weiter",
  "Account updated. We sent a link to the new e-mail address to confirm it.": "Konto aktualisiert. Wir haben einen Link an die neue E-Mail-Adresse geschickt, um sie zu bestätigen.",
  "Create a project": "Ein Projekt anlegen",
  "Projects hold the issues, with their own categories and versions.": "Projekte enthalten die Einträge, mit eigenen Kategorien und Versionen.",
  "Report the first issue": "Den ersten Eintrag melden",
  "A bug, a task or an idea: anything the team should work on.": "Ein Fehler, eine Aufgabe oder eine Idee: alles, woran das Team arbeiten soll.",
  "Invite your team": "Ihr Team einladen",
  "Colleagues get an e-mail with a link to join.": "Kollegen bekommen eine E-Mail mit einem Link zum Beitreten.",
  "Bring your data and tools": "Daten und Werkzeuge anbinden",
  "Import a Mantis database, or connect other tools with an API key or webhooks.": "Importieren Sie eine Mantis-Datenbank oder binden Sie andere Werkzeuge per API-Schlüssel oder Webhooks an.",
  "Get started with {team}": "Erste Schritte mit {team}",
  "{done} of {total} done": "{done} von {total} erledigt",
  "Hide": "Ausblenden",
  "Just looking around?": "Erst einmal umsehen?",
  "Create a sample project with example issues": "Ein Beispielprojekt mit Beispieleinträgen anlegen",
  "(you can delete it later)": "(Sie können es später löschen)",
  "Sample project": "Beispielprojekt",
  "Example issues to try things out. Delete this project when you no longer need it.": "Beispieleinträge zum Ausprobieren. Löschen Sie das Projekt, wenn Sie es nicht mehr brauchen.",
  "General": "Allgemein",
  "The \"Log in\" button does nothing on phones": "Der Button „Anmelden“ reagiert auf Handys nicht",
  "Open the site on a phone and tap \"Log in\": nothing happens. On a computer it works.": "Öffnen Sie die Seite auf einem Handy und tippen Sie auf „Anmelden“: Nichts passiert. Am Computer funktioniert es.",
  "Add a dark mode": "Dunkles Design hinzufügen",
  "Several users work in the evening and asked for a dark theme.": "Mehrere Nutzer arbeiten abends und wünschen sich ein dunkles Design.",
  "Typo on the login page": "Tippfehler auf der Anmeldeseite",
  "\"Montly\" should be \"Monthly\".": "„Monatich“ sollte „Monatlich“ heißen.",
  "I will fix it with the next update.": "Ich behebe das mit dem nächsten Update.",
  "Exporting the report takes a long time": "Der Export des Berichts dauert lange",
  "Exporting the monthly report takes about two minutes.": "Der Export des Monatsberichts dauert etwa zwei Minuten.",
  "How many rows does your report have?": "Wie viele Zeilen hat Ihr Bericht?",
  "The app crashes when an empty form is saved": "Die App stürzt ab, wenn ein leeres Formular gespeichert wird",
  "Open a new form, leave all fields empty and click \"Save\".": "Neues Formular öffnen, alle Felder leer lassen und auf „Speichern“ klicken.",
  "Fixed: an empty form now shows a message instead.": "Behoben: Bei einem leeren Formular erscheint jetzt eine Meldung.",
  "Notifications": "Benachrichtigungen",
  "Mark all as read": "Alle als gelesen markieren",
  "No notifications yet.": "Noch keine Benachrichtigungen.",
  "Someone": "Jemand",
  "{user} mentioned you": "{user} hat Sie erwähnt",
  "{user} reported a new issue": "{user} hat einen neuen Eintrag gemeldet",
  "{user} assigned the issue to you": "{user} hat Ihnen den Eintrag zugewiesen",
  "{user} assigned the issue to {handler}": "{user} hat den Eintrag {handler} zugewiesen",
  "{user} changed the status to {status}": "{user} hat den Status auf {status} geändert",
  "{user} added a note": "{user} hat eine Notiz hinzugefügt",
  "{user} changed the priority": "{user} hat die Priorität geändert",
  "{user} added a relationship": "{user} hat eine Beziehung hinzugefügt",
  "{user} updated the issue": "{user} hat den Eintrag geändert",
  "{user} mentioned you:": "{user} hat Sie erwähnt:",
  "Bold": "Fett",
  "bold text": "fetter Text",
  "Italic": "Kursiv",
  "italic text": "kursiver Text",
  "Code": "Code",
  "Link": "Link",
  "Numbered list": "Nummerierte Liste",
  "Quote": "Zitat",
  "Write": "Schreiben",
  "Preview": "Vorschau",
  "Nothing to preview.": "Nichts anzuzeigen.",
  "Copy as Markdown, to show the image in a text": "Als Markdown kopieren, um das Bild in einem Text zu zeigen",
  "Git (GitHub, GitLab)": "Git (GitHub, GitLab)",
  "Name, e.g. GitHub app": "Name, z. B. GitHub App",
  "Create webhook": "Webhook anlegen",
  "Commits that mention #123 add a note to issue 123; \"fixes #123\" (or closes, resolves) also resolves it. Notes are written in the name of the person who creates the webhook.": "Commits, die #123 erwähnen, fügen dem Eintrag 123 eine Notiz hinzu; „fixes #123“ (oder closes, resolves) löst ihn außerdem. Die Notizen erscheinen im Namen der Person, die den Webhook anlegt.",
  "Webhook \"{name}\" created. Copy the address and the secret now — they are shown only once.": "Webhook „{name}“ angelegt. Kopieren Sie Adresse und Secret jetzt – sie werden nur einmal angezeigt.",
  "Payload URL": "Payload-URL",
  "Secret": "Secret",
  "GitHub: repository → Settings → Webhooks → Add webhook; content type application/json, the secret as \"Secret\", event \"Just the push event\".": "GitHub: Repository → Settings → Webhooks → Add webhook; Content type application/json, das Secret als „Secret“, Ereignis „Just the push event“.",
  "GitLab: project → Settings → Webhooks; the address as URL, the secret as \"Secret token\", trigger \"Push events\".": "GitLab: Projekt → Settings → Webhooks; die Adresse als URL, das Secret als „Secret token“, Auslöser „Push events“.",
  "Notes as": "Notizen als",
  "Resolve on \"fixes #N\"": "Bei „fixes #N“ lösen",
  "Telegram groups": "Telegram-Gruppen",
  "Connect a group": "Gruppe verbinden",
  "A connected group gets new issues, changes and public notes of this team.": "Eine verbundene Gruppe bekommt neue Einträge, Änderungen und öffentliche Notizen dieses Teams.",
  "Add {bot} to the group, then send this message in the group (valid for an hour):": "Fügen Sie {bot} der Gruppe hinzu und senden Sie dann diese Nachricht in der Gruppe (eine Stunde gültig):",
  "the bot": "den Bot",
  "(group without a name)": "(Gruppe ohne Namen)",
  "Disconnect": "Trennen",
  "Telegram": "Telegram",
  "Your notifications also come to Telegram.": "Ihre Benachrichtigungen kommen auch in Telegram an.",
  "Get the notifications of the bell in a chat with our Telegram bot.": "Erhalten Sie die Benachrichtigungen der Glocke in einem Chat mit unserem Telegram-Bot.",
  "Connect Telegram": "Telegram verbinden",
  "Telegram opens; press \"Start\" in the chat. If it did not open:": "Telegram öffnet sich; tippen Sie im Chat auf „Start“. Falls nicht:",
  "Check again": "Erneut prüfen",
  "Notifications stopped.": "Benachrichtigungen beendet.",
  "Hello! Connect your account on the website: My Account → Telegram.": "Hallo! Verbinden Sie Ihr Konto auf der Website: Mein Konto → Telegram.",
  "This code is not valid any more. Create a new one on the website.": "Dieser Code ist nicht mehr gültig. Erstellen Sie auf der Website einen neuen.",
  "Open the link from your account page in a private chat with the bot.": "Öffnen Sie den Link von Ihrer Kontoseite in einem privaten Chat mit dem Bot.",
  "Connected: your {app} notifications come here now. Send /stop to end them.": "Verbunden: Ihre {app}-Benachrichtigungen kommen jetzt hier an. Senden Sie /stop, um sie zu beenden.",
  "Add the bot to a group and send the command there.": "Fügen Sie den Bot einer Gruppe hinzu und senden Sie den Befehl dort.",
  "This chat now gets the updates of the team \"{team}\". Send /stop to end them.": "Dieser Chat bekommt jetzt die Neuigkeiten des Teams „{team}“. Senden Sie /stop, um sie zu beenden.",
  "Open the issue": "Eintrag öffnen",
  "Telegram is not set up on this server.": "Telegram ist auf diesem Server nicht eingerichtet.",
  "Terms of Service": "Nutzungsbedingungen",
  "Privacy Policy": "Datenschutzerklärung",
  "Imprint": "Impressum",
  "Not available": "Nicht verfügbar",
  "This page has not been set up yet.": "Diese Seite ist noch nicht eingerichtet.",
  "By creating an account you agree to the": "Mit dem Anlegen eines Kontos stimmen Sie den",
  "and the": "und der",
  "Site administration": "Seitenverwaltung",
  "Users": "Benutzer",
  "New in 7 days": "Neu in 7 Tagen",
  "New in 30 days": "Neu in 30 Tagen",
  "Active in 7 days": "Aktiv in 7 Tagen",
  "Files": "Dateien",
  "Owner": "Eigentümer",
  "Members": "Mitglieder",
  "operator": "Betreiber",
  "not confirmed": "nicht bestätigt",
  "Disable {user}? They are logged out and cannot log in.": "{user} deaktivieren? Die Person wird abgemeldet und kann sich nicht mehr anmelden.",
  "Disable": "Deaktivieren",
  "Enable": "Aktivieren",
  "Site operator access required.": "Zugriff nur für Betreiber der Seite.",
  "You cannot disable your own account.": "Sie können Ihr eigenes Konto nicht deaktivieren.",
  "Text color": "Textfarbe",
  "Underline": "Unterstrichen",
  "Strikethrough": "Durchgestrichen",
  "Highlight": "Hervorheben",
  "Text size": "Textgröße",
  "Small": "Klein",
  "Heading": "Überschrift",
  "Heading {n}": "Überschrift {n}",
  "Alignment": "Ausrichtung",
  "Left": "Links",
  "Center": "Zentriert",
  "Right": "Rechts",
  "Justify": "Blocksatz",
  "Image": "Bild",
  "Lettered list": "Liste mit Buchstaben",
  "List item": "Listenpunkt",
  "Table": "Tabelle",
  "Horizontal line": "Trennlinie",
  "More": "Mehr",
  "Subscript": "Tiefgestellt",
  "Superscript": "Hochgestellt",
  "Code block": "Codeblock",
  "plain text": "einfacher Text",
  "How the text is written": "Wie der Text geschrieben ist",
  "Auto": "Automatisch",
  "Text": "Text",
  "Image preview": "Bildvorschau",
  "Preview image": "Bild anzeigen",
  "Preview {file}": "{file} anzeigen",
  "Download {file}": "{file} herunterladen",
  "Download": "Herunterladen",
  "Previous image": "Vorheriges Bild",
  "Next image": "Nächstes Bild",
  "Actual size": "Originalgröße",
  "Fit to screen": "An Bildschirm anpassen",
  "Loading image…": "Bild wird geladen…",
  "Could not load this image. You can still download the file.": "Das Bild konnte nicht geladen werden. Sie können die Datei weiterhin herunterladen.",
  "Application updates": "Anwendungsupdates",
  "Fetch the latest main branch, build an isolated release, then restart this application. The page reloads when the new server is ready.": "Den aktuellen main-Branch laden, ein separates Release erstellen und die Anwendung neu starten. Die Seite wird neu geladen, sobald der Server bereit ist.",
  "Back up the database before updating. Commit and push local changes before using this button.": "Vor dem Update die Datenbank sichern. Lokale Änderungen zuerst committen und in das Repository pushen.",
  "The update did not finish in time. Check the server update logs before retrying.": "Das Update wurde nicht rechtzeitig abgeschlossen. Vor einem erneuten Versuch die Update-Protokolle des Servers prüfen.",
  "The application updater must be installed and enabled on this server first.": "Der Update-Dienst muss zuerst auf diesem Server installiert und aktiviert werden.",
  "Application update completed.": "Anwendungsupdate abgeschlossen.",
  "Update requested. Waiting for the updated server; a brief connection interruption is expected.": "Update angefordert. Warten auf den aktualisierten Server; die Verbindung wird kurz unterbrochen.",
  "Build and restart the Böning application from origin/main?": "Die Böning-Anwendung aus origin/main erstellen und neu starten?",
  "Updating…": "Update läuft…",
  "Update from Git and restart": "Aus Git aktualisieren und neu starten",
  "Fetching origin/main and checking the deployment checkout.": "origin/main wird geladen und die Arbeitskopie geprüft.",
  "Building the fetched revision in an isolated release directory.": "Die geladene Version wird in einem separaten Release-Verzeichnis erstellt.",
  "Build succeeded. Restarting the application.": "Build erfolgreich. Die Anwendung wird neu gestartet.",
  "Attachment previews": "Anhangsvorschau",
  "Maximum preview size": "Maximale Vorschaugröße",
  "Images and video players fit within this size without cropping. Smaller screens limit the width automatically.": "Bilder und Videoplayer passen ohne Zuschnitt in diese Größe. Auf kleineren Bildschirmen wird die Breite automatisch begrenzt.",
  "Example — changes immediately": "Beispiel – wird sofort angepasst",
  "Example attachment preview": "Beispiel einer Anhangsvorschau",
  "Performance overview": "Leistungsübersicht",
  "Save your preferences to use this size on issue attachments.": "Speichern Sie Ihre Einstellungen, um diese Größe für Anhänge in Einträgen zu verwenden.",
  "Preview video": "Videovorschau",
  "Play video": "Video abspielen",
  "Play {file}": "{file} abspielen",
  "Video preview: {file}": "Videovorschau: {file}",
  "Hide video": "Video ausblenden",
  "This video could not be played in your browser. Download it to watch it in another player.": "Dieses Video konnte im Browser nicht abgespielt werden. Laden Sie es herunter, um es in einem anderen Player anzusehen.",
  "Effort & complexity": "Aufwand & Komplexität",
  "Complexity / Story points": "Komplexität / Story Points",
  "Story points": "Story Points",
  "Not set": "Nicht festgelegt",
  "Not rated": "Nicht geschätzt",
  "Estimated time": "Geschätzter Aufwand",
  "Estimated time (HH:MM)": "Geschätzter Aufwand (HH:MM)",
  "Needed time (actual)": "Benötigte Zeit (tatsächlich)",
  "Needed time (actual, HH:MM)": "Benötigte Zeit (tatsächlich, HH:MM)",
  "From time entries": "Aus Zeiteinträgen",
  "Manual total": "Manueller Gesamtwert",
  "Auto: {time}": "Automatisch: {time}",
  "Leave blank to use logged time. A manual total replaces it; the two are never added together.": "Leer lassen, um Zeiteinträge zu verwenden. Ein manueller Gesamtwert ersetzt diese; beide werden nie addiert.",
  "Story points describe complexity, not hours. Estimates are optional and can change as you learn.": "Story Points beschreiben Komplexität, keine Stunden. Schätzungen sind optional und können mit neuen Erkenntnissen angepasst werden.",
  "Estimation scale and meaning": "Schätzskala und Bedeutung",
  "Enter effort as H:MM or decimal hours.": "Aufwand als H:MM oder Dezimalstunden eingeben.",
  "Project effort overview": "Projektaufwand im Überblick",
  "Totals include only issues and time entries you can access. Coffee and question-mark estimates are counted separately from numeric points.": "Summen enthalten nur zugängliche Einträge und Zeiteinträge. Kaffee und Fragezeichen werden getrennt von numerischen Punkten gezählt.",
  "{count} issues need refinement, research or a planning pause.": "{count} Einträge benötigen Verfeinerung, Recherche oder eine Planungspause.",
  "No effort": "Kein Aufwand",
  "Already complete or virtually no work.": "Bereits erledigt oder praktisch keine Arbeit.",
  "Very small & trivial": "Sehr klein & trivial",
  "A familiar, simple task with no unknowns. A useful reference story.": "Eine vertraute, einfache Aufgabe ohne Unbekannte. Eine geeignete Referenz-Story.",
  "Small & routine": "Klein & routinemäßig",
  "A little more work, with clear requirements and a familiar solution.": "Etwas mehr Arbeit mit klaren Anforderungen und einer vertrauten Lösung.",
  "Medium": "Mittelgroß",
  "A normal, well-defined story with moderate work and a clear approach.": "Eine normale, klar definierte Story mit moderatem Aufwand und einem klaren Vorgehen.",
  "Large": "Groß",
  "Noticeable effort, with some complexity, unknowns or dependencies.": "Spürbarer Aufwand mit etwas Komplexität, Unbekannten oder Abhängigkeiten.",
  "Very large & complex": "Sehr groß & komplex",
  "Significant complexity or risk. The largest story to plan into one sprint.": "Erhebliche Komplexität oder Risiken. Die größte Story für einen einzelnen Sprint.",
  "Epic — split before a sprint": "Epic – vor dem Sprint aufteilen",
  "Too large or uncertain for one sprint. Break it into smaller stories.": "Für einen Sprint zu groß oder unklar. In kleinere Stories aufteilen.",
  "Huge": "Riesig",
  "A whole feature or module that needs more design and refinement.": "Eine ganze Funktion oder ein Modul, das weitere Konzeption und Verfeinerung benötigt.",
  "Huge / incomplete": "Riesig / unvollständig",
  "A large area of work with fundamental decisions still missing.": "Ein großes Arbeitspaket, bei dem grundlegende Entscheidungen noch fehlen.",
  "Complete unknown": "Komplett unbekannt",
  "Start with research or a spike to understand the problem.": "Mit Recherche oder einem Spike beginnen, um das Problem zu verstehen.",
  "Break needed": "Pause nötig",
  "A planning-poker pause. This is not a numeric estimate.": "Eine Pause beim Planning Poker. Dies ist keine numerische Schätzung.",
  "Needs clarification": "Klärung nötig",
  "Requirements or important information are missing. This is not a numeric estimate.": "Anforderungen oder wichtige Informationen fehlen. Dies ist keine numerische Schätzung.",
  "Preparing a compatible video preview…": "Eine kompatible Videovorschau wird vorbereitet…",
  "Download original": "Original herunterladen",
  "Drag to change the order": "Ziehen, um die Reihenfolge zu ändern",
  "You cannot change the order of notes.": "Sie können die Reihenfolge der Notizen nicht ändern.",
  "You cannot change the order of attachments.": "Sie können die Reihenfolge der Anhänge nicht ändern.",
  "The target note is not part of this issue.": "Die Zielnotiz gehört nicht zu diesem Eintrag.",
  "Files can only be reordered within the same list.": "Dateien können nur innerhalb derselben Liste umsortiert werden.",
  "Calculate from status history (confirmed → resolved)": "Aus dem Statusverlauf berechnen (bestätigt → erledigt)",
  "Needed time from the status history": "Benötigte Zeit aus dem Statusverlauf",
  "Calendar time": "Kalenderzeit",
  "This is how long the issue was open, not the working time. Change it if needed.": "Das ist die Zeit, die der Eintrag offen war, nicht die Arbeitszeit. Bei Bedarf anpassen.",
  "Use this time": "Diese Zeit übernehmen",
  "{days} d {time} h": "{days} T {time} Std.",
  "{time} h": "{time} Std.",
  "or paste a screenshot, or drop files on the form": "oder einen Screenshot einfügen oder Dateien auf das Formular ziehen",
  "Projects overview": "Projektübersicht",
  "Project activities": "Projektaktivitäten",
  "Recent activities": "Letzte Aktivitäten",
  "Active target versions": "Aktive Zielversionen",
  "Activity in the last": "Aktivität der letzten",
  "Added issues": "Neue Einträge",
  "An issue resolved or closed more than once counts once, at the last time. Story points and needed time belong to the period in which the issue was resolved.": "Ein mehrfach erledigter oder geschlossener Eintrag zählt einmal, zum letzten Zeitpunkt. Story Points und benötigte Zeit zählen in dem Zeitraum, in dem der Eintrag erledigt wurde.",
  "Changes": "Änderungen",
  "Changes in the last {n} weeks": "Änderungen der letzten {n} Wochen",
  "Day": "Tag",
  "Week": "Woche",
  "Month": "Monat",
  "Year": "Jahr",
  "Finished (resolved)": "Fertig (erledigt)",
  "Tested (closed)": "Getestet (geschlossen)",
  "From": "Von",
  "To": "Bis",
  "Per": "Pro",
  "Period": "Zeitraum",
  "Progress": "Fortschritt",
  "Involved projects": "Beteiligte Projekte",
  "Involved users": "Beteiligte Benutzer",
  "Issues that became closed": "Einträge, die geschlossen wurden",
  "Issues that became resolved": "Einträge, die erledigt wurden",
  "Last activity": "Letzte Aktivität",
  "Needed time": "Benötigte Zeit",
  "Needed time of the issues resolved in the period": "Benötigte Zeit der im Zeitraum erledigten Einträge",
  "Story points (done / open)": "Story Points (fertig / offen)",
  "Story points of resolved issues / of open issues": "Story Points erledigter / offener Einträge",
  "Story points of the issues resolved in the period": "Story Points der im Zeitraum erledigten Einträge",
  "There are no active target versions.": "Es gibt keine aktiven Zielversionen.",
  "Week of {date}": "Woche ab {date}",
  "{done} of {total} resolved ({pct}%)": "{done} von {total} erledigt ({pct} %)",
  "{n} not estimated": "{n} nicht geschätzt",
  "The start must be before the end.": "Der Beginn muss vor dem Ende liegen.",
  "Too many rows: choose a larger time unit or a shorter range.": "Zu viele Zeilen: größere Zeiteinheit oder kürzeren Zeitraum wählen.",
  "{n} weeks": {"one": "{n} Woche", "other": "{n} Wochen"},
  "Note by {user}": "Notiz von {user}",
  "You receive this e-mail because you take part in this issue.": "Sie erhalten diese E-Mail, weil Sie an diesem Eintrag beteiligt sind.",
  "E-mail settings": "E-Mail-Einstellungen",
  "Planned target versions": "Geplante Zielversionen",
  "Only issues planned for a target version that is not released yet are counted.": "Gezählt werden nur Einträge mit einer noch nicht veröffentlichten Zielversion.",
  "Previous page": "Vorherige Seite",
  "Next page": "Nächste Seite"
};

export default dict;
